const fmt = new Map<string, Intl.NumberFormat>();

export function money(minor: number, currency = "RON") {
  let f = fmt.get(currency);
  if (!f) fmt.set(currency, (f = new Intl.NumberFormat("ro-RO", { style: "currency", currency })));
  return f.format(minor / 100);
}

// toMinor transformă „149,99” / „149.99” în 14999 (bani). null dacă e invalid.
export function toMinor(s: string): number | null {
  const t = s.trim().replace(/\s/g, "").replace(",", ".");
  if (t === "") return null;
  const n = Number(t);
  return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) : null;
}

export const fromMinor = (n: number | null | undefined) => (n == null ? "" : (n / 100).toFixed(2));

export const date = (s: string) =>
  new Date(s).toLocaleString("ro-RO", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const ORDER_STATUS: Record<string, { label: string; tone: Tone }> = {
  pending: { label: "Nouă", tone: "amber" },
  confirmed: { label: "Confirmată", tone: "blue" },
  processing: { label: "În procesare", tone: "blue" },
  shipped: { label: "Expediată", tone: "violet" },
  delivered: { label: "Livrată", tone: "green" },
  cancelled: { label: "Anulată", tone: "gray" },
  returned: { label: "Returnată", tone: "red" },
};

export const PAYMENT_STATUS: Record<string, { label: string; tone: Tone }> = {
  pending: { label: "Neîncasată", tone: "amber" },
  paid: { label: "Plătită", tone: "green" },
  refunded: { label: "Rambursată", tone: "gray" },
  failed: { label: "Eșuată", tone: "red" },
};

export const PAYMENT_METHOD: Record<string, string> = { cod: "Ramburs", bank_transfer: "Ordin de plată" };

// Tranzițiile permise (oglindă a mașinii de stări din API; API-ul rămâne autoritar).
export const TRANSITIONS: Record<string, string[]> = {
  pending: ["confirmed", "cancelled"],
  confirmed: ["processing", "shipped", "cancelled"],
  processing: ["shipped", "cancelled"],
  shipped: ["delivered", "returned"],
  delivered: ["returned"],
};

export type Tone = "gray" | "green" | "amber" | "blue" | "violet" | "red";

// Statusurile tichetelor de suport, din perspectiva comerciantului.
export const TICKET_STATUS: Record<string, { label: string; tone: Tone }> = {
  open: { label: "În așteptarea echipei", tone: "amber" },
  waiting_merchant: { label: "Răspuns nou", tone: "blue" },
  resolved: { label: "Rezolvat", tone: "green" },
  closed: { label: "Închis", tone: "gray" },
};

export const TICKET_CATEGORY: Record<string, string> = {
  billing: "Facturare", technical: "Problemă tehnică", account: "Cont", other: "Altele",
};

// Emailurile tranzacționale: etichete pentru istoric și setări.
export const EMAIL_LABEL: Record<string, string> = {
  order_confirmation: "Confirmarea comenzii",
  order_shipped: "Comanda a fost expediată",
  order_cancelled: "Comanda a fost anulată",
  payment_received: "Plata a fost primită (ordin de plată)",
  merchant_new_order: "Notificare comandă nouă (către tine)",
};

export const EMAIL_STATUS: Record<string, { label: string; tone: Tone }> = {
  pending: { label: "în curs", tone: "amber" },
  sent: { label: "trimis", tone: "green" },
  failed: { label: "eșuat", tone: "red" },
  skipped: { label: "netrimis", tone: "gray" },
};
